import { Dialog as D } from "radix-ui";
import { X } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/cn";
import { Button } from "./button";

export const DialogRoot = D.Root;
export const DialogTrigger = D.Trigger;
export const DialogClose = D.Close;

/** 对话框（原型 .dialog）：标题 + 关闭按钮，body / foot 由调用方给；actions 放在关闭按钮左侧（如全屏切换）。closable=false 时不显示关闭按钮。 */
export function DialogContent({ title, description, children, footer, actions, className, maxWidth = 640, onEscapeKeyDown, closable = true }: {
  title: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  footer?: ReactNode;
  actions?: ReactNode;
  className?: string;
  maxWidth?: number | "none";
  onEscapeKeyDown?: (e: KeyboardEvent) => void;
  closable?: boolean;
}) {
  return (
    <D.Portal>
      <D.Overlay className="dialog-overlay" />
      <D.Content className={cn("dialog dialog-pos", className)} style={{ maxWidth }} onEscapeKeyDown={onEscapeKeyDown} aria-describedby={description ? undefined : undefined}>
        <div className="dialog-head">
          <div className="flex min-w-0 flex-col gap-1">
            <D.Title className="display-lg">{title}</D.Title>
            {description ? <D.Description className="page-sub">{description}</D.Description> : <D.Description className="sr-only">{typeof title === "string" ? title : "对话框"}</D.Description>}
          </div>
          <div className="flex shrink-0 items-center gap-1">
            {actions}
            {closable ? (
              <D.Close asChild>
                <Button variant="ghost" size="icon" aria-label="关闭">
                  <X className="ico" />
                </Button>
              </D.Close>
            ) : null}
          </div>
        </div>
        {children ? <div className="dialog-body">{children}</div> : null}
        {footer ? <div className="dialog-foot">{footer}</div> : null}
      </D.Content>
    </D.Portal>
  );
}
